import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import { adminCountriesAPI } from '../services/api';

const CountryEditPage = () => {
  const { countryId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', sort_order: '0', is_allowed: true });
  const [countryCode, setCountryCode] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await adminCountriesAPI.getAll();
        const rows = response.data?.countries || [];
        const c = rows.find((x) => String(x.id) === String(countryId));
        if (!cancelled) {
          if (c) {
            setCountryCode(c.code || '');
            setFormData({
              name: c.name || '',
              sort_order: String(c.sort_order ?? 0),
              is_allowed: !!c.is_allowed,
            });
          } else {
            toast.error('Country not found');
          }
        }
      } catch (error) {
        if (!cancelled) toast.error(error.response?.data?.message || error.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [countryId]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await adminCountriesAPI.update(countryId, {
        name: formData.name.trim(),
        sort_order: parseInt(formData.sort_order, 10) || 0,
        is_allowed: formData.is_allowed,
      });
      toast.success('Country updated');
      navigate('/countries');
    } catch (error) {
      toast.error('Error saving: ' + (error.response?.data?.message || error.message));
    }
  };

  const title = countryCode ? `Edit country (${countryCode})` : 'Edit country';

  return (
    <AdminSubpage title={title} backTo="/countries">
      {loading ? (
        <div className="loading">Loading…</div>
      ) : (
        <div className="admin-page-panel modal-content">
          <form onSubmit={submit}>
            <div className="form-group">
              <label>Name</label>
              <input
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={120}
              />
            </div>
            <div className="form-group">
              <label>Sort order</label>
              <input
                type="number"
                min="0"
                value={formData.sort_order}
                onChange={(e) => setFormData({ ...formData, sort_order: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.is_allowed}
                  onChange={(e) => setFormData({ ...formData, is_allowed: e.target.checked })}
                />{' '}
                Allowed at checkout
              </label>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Save
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/countries')}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </AdminSubpage>
  );
};

export default CountryEditPage;
